module.exports = __webpack_public_path__ + "img/sanae kochiya lunar war oracle_sc2.e7a46773.png";